@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.container {
  padding: @space-8;
  border: 1px dashed var(--grey-600);
  position: relative;
  display: inline-flex;
}

.images-container {
  gap: @space-8;
}

.image-container {
  position: relative;
}

.image {
  height: 108px;
  width: 70px;
}

.landscape-image {
  width: 108px;
  height: 70px;
}

.text-container {
  position: absolute;
  inset: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.text {
  color: var(--white);
  text-align: center;
  background: var(--grey-900);
  width: 68px;
  padding: @space-4 @space-8;
}

.landscape-text {
  width: 104px;
}
